import api from '~/services/api';

const getAuthorizedApps = () =>
  api.request({
    method: 'GET',
    url: '/ui/oauth/authorized_client_apps',
  });

// It is optional in usage. Should it be?
const deleteAuthorizedApps = (id?: string) =>
  api.request({
    method: 'DELETE',
    url: `/ui/oauth/authorized_client_apps/${id}`,
  });
export { deleteAuthorizedApps, getAuthorizedApps };
